// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__XLsaI","icon__Wrap":"styles_icon__Wrap__1dtEC","back_icon":"styles_back_icon__svDz4","features__Wrap":"styles_features__Wrap__MHiw9"};